import moment, { Moment } from 'moment'
import { apiFormat } from './apiFormat'
import { DateTimeFormat } from './enum'

/**
 * Days to add to reach the next working day (Mon–Fri), indexed by moment().day()
 *
 * Index:  [Sun=0, Mon=1, Tue=2, Wed=3, Thu=4, Fri=5, Sat=6]
 * Offset: [  +1,   +1,   +1,   +1,   +1,   +3,   +2]
 *
 * Friday  (+3) → skips Sat + Sun → Monday
 * Saturday(+2) → skips Sun      → Monday
 * Sun–Thu (+1) → next day is already a weekday
 */
const NEXT_WORKDAY_OFFSET = [1, 1, 1, 1, 1, 3, 2] as const

export function getNextWorkingDay(type: DateTimeFormat, m?: Moment): string {
  const base = m ?? moment()

  if (!base.isValid()) {
    throw new Error(`Received an invalid moment — "${base.toString()}"`)
  }

  // Set to next working day using offset lookup
  const next = base.clone().add(NEXT_WORKDAY_OFFSET[base.day()], 'days')

  switch (type) {
    case DateTimeFormat.DATE:
      return next.format(apiFormat.yearMonthDay)

    case DateTimeFormat.ISO_DATETIME:
      return next.set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toISOString()

    default:
      throw new Error(`Unknown DateFormatType — "${type}"`)
  }
}
